export default "__VITE_ASSET__00664a3a__"